import { StarbaseEntity, Serializable } from 'starbase-launcher';
import { ITableColumn, TableColumn, ColumnDataTypes, DropdownTableColumn, ColumnDropdownData, CurrencyTableColumn, DecimalTableColumn } from 'new-table-editor';
import { LU_SubscriptionPriceModel_ext } from './lu_subscriptionprice';

// eslint-disable-next-line @typescript-eslint/naming-convention
export class LU_SubscriptionDiscountModel extends StarbaseEntity implements Serializable<LU_SubscriptionDiscountModel> {
  public discountDescription: string;
  public discountCode: string;
  public subscriptionPriceUID: number;
  public subscriptionPrice: LU_SubscriptionPriceModel_ext;
  public discountPercentage: number;
  public discountFixedAmount: number;
  public discountDuration: number;
  public discountDeadline: Date;
  public active: boolean;
  public readonly timesUsed: number;

  public static TableColumns(showUID = false, showGUID = false, showWhodunits = false, prices: LU_SubscriptionPriceModel_ext[]): ITableColumn[] {
    const codeCol = new TableColumn('discountCode', 'Discount code', ColumnDataTypes.string, true, true, true);
    codeCol.tooltip = 'Customer must type this code during purchase to redeem discount';

    const descCol = new TableColumn('discountDescription', 'Description', ColumnDataTypes.string, false, true, false);

    const priceCol = new DropdownTableColumn(
      'subscriptionPrice',
      'Plan',
      'subscriptionPriceUID',
      new ColumnDropdownData(prices),
      true,
      true,
      false);
    priceCol.dropdownData.setup('name', 'uid');
    priceCol.tooltip = 'Subscription to which discount will be applied';

    const percentCol = new DecimalTableColumn('discountPercentage', ' %', false, true, false, '0');
    percentCol.tooltip = 'Percentage of discount';
    percentCol.minValue = 0;
    percentCol.maxValue = 100;
    percentCol.numberDigitsAfterDecimal = 0;
    percentCol.colMaxWidth = '55px';
    percentCol.colWidth = '50px';
    percentCol.textAlignment = 'center';
    percentCol.placeholder = '  %';

    const fixedCol = new CurrencyTableColumn('discountFixedAmount', 'Amount', false, true, false, '0.00');
    fixedCol.tooltip = 'Fixed discount amount (takes precedence over percentage)';
    fixedCol.minValue = 0;
    fixedCol.placeholder = '0.00';

    const durationCol = new TableColumn('discountDuration', 'Duration', ColumnDataTypes.number, false, true, false);
    durationCol.tooltip = 'Duration of discount in days';
    durationCol.textAlignment = 'center';
    durationCol.visible = false;

    const deadlineCol = new TableColumn('discountDeadline', 'Expiration', ColumnDataTypes.date, true, true, false);
    deadlineCol.tooltip = 'Discount expiration date. Must be redeemed by this date';

    const activeCol = new TableColumn('active', 'Active', ColumnDataTypes.yesno, true, true, false, true);

    const usedCol = new TableColumn('timesUsed', 'Used', ColumnDataTypes.number, false, false);
    usedCol.tooltip = 'Number of times this discount has been successfully applied.';

    return [
      ...TableColumn.generateColumnsForStarbaseEntity(showUID, showGUID, showWhodunits),
      codeCol,
      descCol,
      priceCol,
      percentCol,
      fixedCol,
      durationCol,
      deadlineCol,
      activeCol,
      usedCol
    ];
  }

  deserialize(input) {
    return Object.assign(new LU_SubscriptionDiscountModel(), input);
  }
}
